import { ActiveToast } from 'ngx-toastr/toastr/toastr.service';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Injectable, Injector } from '@angular/core';
import { TranslationService } from '../internationalization/translation.service';
import { ILocalizedToasterService } from 'shared-components';

declare type ToastType = 'success' | 'info' | 'warning' | 'error';

@Injectable({
  providedIn: 'root'
  })
export class LocalizedToasterService implements ILocalizedToasterService{
  public constructor(
    private readonly toastr: ToastrService,
    private readonly injector: Injector) { }

  private translate(value: string): string {
    return value ? this.injector.get(TranslationService).instant(value) : '';
  }

  public pop(type: ToastType, title: string, body = '', config?: Partial<IndividualConfig>): ActiveToast<any> {
    const toast = this.toastr[type](this.translate(body), this.translate(title), { positionClass: 'toast-bottom-right', ...config});
    this.setDataTestId(toast, `toast-${type}`);
    return toast;
  }

  public success(title: string, body?: string, config?: Partial<IndividualConfig>): ActiveToast<any> {
    return this.pop('success', title, body, config);
  }

  public info(title: string, body?: string, config?: Partial<IndividualConfig>): ActiveToast<any> {
    return this.pop('info', title, body, config);
  }

  public error(title: string, body?: string, config?: Partial<IndividualConfig>): ActiveToast<any> {
    return this.pop('error', title, body, config);
  }

  public warn(title: string, body?: string, config?: Partial<IndividualConfig>): ActiveToast<any> {
    return this.pop('warning', title, body, config);
  }

  public persistedError(title: string, body?: string): ActiveToast<any> {
    const toast = this.toastr.error(body, title, { disableTimeOut: true});
    this.setDataTestId(toast, 'toast-persisted-error');
    return toast;
  }

  public clear(toastId?: number): void {
    this.toastr.clear(toastId);
  }

  private setDataTestId(toast: ActiveToast<any>, testId: string): void {
    toast.portal?.location?.nativeElement?.setAttribute('data-testid', testId);
  }

  public khError(data: any): ActiveToast<any> {
    let message = Array.isArray(data?.error?.Errors) && data.error.Errors.length > 0 ? data.error.Errors[0] : '';
    if(!message){
      message = data?.ExceptionMessage ?? '';
    }

    return this.error('Error', message);
  }
}